import React, { useContext, useState } from 'react';
import AppContext from '../../context/app/appContext';
import Parser from 'html-react-parser';

const LoadMore = () => {
  const appContext = useContext(AppContext);
  const { translations, loadMorePosts, readMoreloading } = appContext;

  const [ pageNr, setPageNr ] = useState(1);

  const onClick = () => {
    setPageNr(pageNr + 1);
    loadMorePosts(pageNr + 1);
  }

  return (
    <div className="js-component-archive-load-more component-archive-load-more row">
      <div className="col-12 col-sm-10 col-md-6 mx-auto">
        <button
          className={`btn btn-list w-100${readMoreloading ? ' btn-loading-green' : ''}`}
          onClick={onClick}
        >
          <span>{Parser(translations.seeMoreArticles)}</span>
        </button>
      </div>
    </div>
  )
}

export default LoadMore;



// WEBPACK FOOTER //
// ./src/components/LoadMore/LoadMore.js